import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Ban, X } from 'lucide-react'
import { tr } from 'i18n'
import s from '../Management.module.scss'
import './DriverBlockDialog.scss'

type Props = { name: string; busy: boolean; error: string; onClose: () => void; onConfirm: (reason: string) => void }

export default function DriverBlockDialog({ name, busy, error, onClose, onConfirm }: Props) {
  useTranslation()
  const [reason, setReason] = useState('')
  return <div className={s.overlay}>
    <form className={`${s.dialog} driver-block-dialog`} role="dialog" aria-modal="true" aria-labelledby="driver-block-title"
      onSubmit={event => { event.preventDefault(); if (reason.trim()) onConfirm(reason.trim()) }}>
      <h2 id="driver-block-title"><Ban size={20} aria-hidden="true" />{tr('Блокировка водителя')}</h2>
      <p>{name}</p>
      <p className={s.muted}>{tr('Водитель увидит эту причину в личном кабинете.')}</p>
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      <label className={s.field}>{tr('Причина блокировки')}<textarea required autoFocus rows={4} maxLength={1000}
        value={reason} onChange={event => setReason(event.target.value)} placeholder={tr('Укажите причину блокировки')} /></label>
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}><X size={14} aria-hidden="true" />{tr('Отмена')}</button>
        <button className={s.danger} disabled={busy || !reason.trim()}><Ban size={14} aria-hidden="true" />{tr('Заблокировать')}</button>
      </div>
    </form>
  </div>
}
